import { registerSchema } from '@erikdakoda/utils/schemaRegistry';
import {
  AnalyzeCoachConvoSchema,
  CoachingAnalysisSchema,
  coachingAnalysisFormat,
} from '../server/AnalyzeCoachConvoSchema';

/**
 * Registers uvilo-ai coaching analysis and analyze-coach-convo schemas.
 * Always re-registers (HMR-safe) so schema edits replace the prior Zod contract.
 * Safe to call from app `initPackages` after vocabulary seeding.
 */
export function seedUviloAnalysisSchemas(): void {
  registerSchema({
    app: 'uvilo-ai',
    name: 'coaching-analysis',
    version: 1,
    zodSchema: CoachingAnalysisSchema,
    format: coachingAnalysisFormat,
  });

  registerSchema({
    app: 'uvilo-ai',
    name: 'analyze-coach-convo',
    version: 1,
    zodSchema: AnalyzeCoachConvoSchema,
    format: {},
  });
}
